import { SELECT_ALL_VALUE } from "../constants/ui";

const transformFormFieldValue = (values: string[] | null): string[] | null => {
  if (!values) {
    return [];
  }

  if (values[0] === SELECT_ALL_VALUE) {
    return null;
  }

  return values;
};

export default transformFormFieldValue;
